import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-backdrop" }, null, -1)
const _hoisted_2 = { class: "m-subscribe-modal-container" }
const _hoisted_3 = { class: "m-subscribe-modal-close" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Never miss a drop")
const _hoisted_7 = { class: "m-subscribe-actions-container" }
const _hoisted_8 = {
  key: 0,
  class: "m-subscribe-action-with-icon"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "m-subscribe-bell"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Subscribe ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}
const _hoisted_13 = { class: "m-subscribe-modal-close" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Connect your wallet")
const _hoisted_17 = { class: "m-subscribe-modal-close" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Verify your wallet")
const _hoisted_21 = { class: "m-subscribe-actions-container" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "spinner"
}
const _hoisted_24 = { class: "m-subscribe-modal-close" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Never miss a drop")
const _hoisted_28 = {
  key: 0,
  class: "m-subscribe-form-error"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "m-subscribe-privacy" }, [
  /*#__PURE__*/_createTextVNode(" By subscribing you agree to our "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://manifoldxyz.notion.site/Privacy-Policy-bfc497773ea048d08dfa96644cb48adc"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and to receive periodic updates. ")
], -1)
const _hoisted_30 = { class: "m-subscribe-actions-container" }
const _hoisted_31 = {
  type: "submit",
  class: "m-subscribe-action"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "spinner"
}
const _hoisted_34 = { class: "m-subscribe-modal-close" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createTextVNode("You are almost there")
const _hoisted_38 = {
  key: 0,
  class: "m-subscribe-form-email-sent"
}
const _hoisted_39 = {
  key: 1,
  class: "m-subscribe-form-error"
}
const _hoisted_40 = { class: "m-subscribe-actions-container" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "spinner"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://notifications.manifold.xyz",
    target: "_blank"
  }, " Change email ")
], -1)
const _hoisted_44 = { class: "m-subscribe-modal-close" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "h-6 w-6" }, "x", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Sorry to see you go")
const _hoisted_48 = {
  key: 0,
  class: "m-subscribe-form-error"
}
const _hoisted_49 = { class: "m-subscribe-actions-container" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = {
  key: 1,
  class: "spinner"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "m-subscribe-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://notifications.manifold.xyz",
    target: "_blank"
  }, " Manage notifications ")
], -1)
const _hoisted_53 = {
  key: 0,
  class: "m-subscribe-button-loading"
}
const _hoisted_54 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "m-subscribe-bell"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
}, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Subscribe ")
const _hoisted_58 = {
  key: 0,
  class: "m-subscribe-button-loading"
}
const _hoisted_59 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "m-subscribe-bell"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M9.143 17.082a24.248 24.248 0 003.844.148m-3.844-.148a23.856 23.856 0 01-5.455-1.31 8.964 8.964 0 002.3-5.542m3.155 6.852a3 3 0 005.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 003.536-1.003A8.967 8.967 0 0118 9.75V9A6 6 0 006.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53"
}, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Unsubscribe ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogDescription = _resolveComponent("DialogDescription")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.DATA_WIDGET_VALUE + ' manifold')
  }, [
    (_ctx.isModalOpen)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          class: "m-widget-subscribe",
          static: "",
          open: _ctx.isModalOpen,
          onClose: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showPromptSubscribe)
                ? (_openBlock(), _createBlock(_component_DialogPanel, {
                    key: 0,
                    class: "m-subscribe-modal m-subscribe-modal-prompt"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, _hoisted_5)
                      ]),
                      _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Subscribe to all updates from " + _toDisplayString(_ctx.ensOrWallet), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "m-subscribe-action",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubscribe && _ctx.handleSubscribe(...args)))
                        }, [
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("i", _hoisted_12))
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_ctx.state === _ctx.State.NotConnected)
                  ? (_openBlock(), _createBlock(_component_DialogPanel, {
                      key: 1,
                      class: "m-subscribe-modal"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                          }, _hoisted_15)
                        ]),
                        _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" You need to connect your wallet to be able to subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (_ctx.state === _ctx.State.NotAuthenticated)
                    ? (_openBlock(), _createBlock(_component_DialogPanel, {
                        key: 2,
                        class: "m-subscribe-modal"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                            }, _hoisted_19)
                          ]),
                          _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Verify your wallet by signing with it to be able to subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "m-subscribe-action",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.verifyWallet && _ctx.verifyWallet(...args)))
                            }, [
                              (!_ctx.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Verify Wallet"))
                                : (_openBlock(), _createElementBlock("i", _hoisted_23))
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : (_ctx.state === _ctx.State.NotSubscribedNoEmail)
                      ? (_openBlock(), _createBlock(_component_DialogPanel, {
                          key: 3,
                          class: "m-subscribe-modal"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                              }, _hoisted_26)
                            ]),
                            _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                              default: _withCtx(() => [
                                _hoisted_27
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Add your email to subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("form", {
                              class: "m-subscribe-form",
                              onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.subscribe && _ctx.subscribe(...args)), ["prevent"]))
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event)),
                                class: "m-subscribe-email-input",
                                name: "email",
                                type: "email",
                                placeholder: "example@manifold.xyz"
                              }, null, 512), [
                                [_vModelText, _ctx.email]
                              ]),
                              (_ctx.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.error), 1))
                                : _createCommentVNode("", true),
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("button", _hoisted_31, [
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Subscribe to " + _toDisplayString(_ctx.ensOrWallet), 1))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_33))
                                ])
                              ])
                            ], 32)
                          ]),
                          _: 1
                        }))
                      : (_ctx.state === _ctx.State.SubscribedNotVerified)
                        ? (_openBlock(), _createBlock(_component_DialogPanel, {
                            key: 4,
                            class: "m-subscribe-modal"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                                }, _hoisted_36)
                              ]),
                              _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Verify your email to complete your subscription. An email was sent to " + _toDisplayString(_ctx.email) + " and may take up to 2 minutes to arrive. ", 1)
                                ]),
                                _: 1
                              }),
                              (_ctx.verificationEmailSent)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_38, " New email sent "))
                                : _createCommentVNode("", true),
                              (_ctx.error)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.error), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "m-subscribe-action",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resendVerificationEmail && _ctx.resendVerificationEmail(...args)))
                                }, [
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Resend verification email"))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_42))
                                ])
                              ]),
                              _hoisted_43
                            ]),
                            _: 1
                          }))
                        : (_ctx.state === _ctx.State.Subscribed)
                          ? (_openBlock(), _createBlock(_component_DialogPanel, {
                              key: 5,
                              class: "m-subscribe-modal"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                                  }, _hoisted_46)
                                ]),
                                _createVNode(_component_DialogTitle, { class: "m-subscribe-title" }, {
                                  default: _withCtx(() => [
                                    _hoisted_47
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_DialogDescription, { class: "m-subscribe-description" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Are you sure you want to stop getting updates from " + _toDisplayString(_ctx.ensOrWallet) + "? ", 1)
                                  ]),
                                  _: 1
                                }),
                                (_ctx.error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.error), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "m-subscribe-action",
                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.unsubscribe && _ctx.unsubscribe(...args)))
                                  }, [
                                    (!_ctx.loading)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Unsubscribe"))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_51))
                                  ])
                                ]),
                                _hoisted_52
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["open", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.state !== _ctx.State.Subscribed)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "m-subscribe-button",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleSubscribe && _ctx.handleSubscribe(...args)))
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("i", _hoisted_53))
            : (_openBlock(), _createElementBlock("svg", _hoisted_54, _hoisted_56)),
          _hoisted_57
        ]))
      : (_ctx.state === _ctx.State.Subscribed)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "m-subscribe-button",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleUnsubscribe && _ctx.handleUnsubscribe(...args)))
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_58))
              : (_openBlock(), _createElementBlock("svg", _hoisted_59, _hoisted_61)),
            _hoisted_62
          ]))
        : _createCommentVNode("", true)
  ], 2))
}